import { useMemo } from 'react'

import { Select } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { FormilyProps } from '@eastcoal/formily/types/component'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { MemberDeptUserCascader } from '../MemberDeptUser/Cascader'

export const MemberAgentCascader = ({
  disabled,
  value,
  onChange
}: FormilyProps) => {
  const detailData = useCrudFormStore(state => state.detailData)
  const { profileId, user } = useAuthStore(state =>
    pick(state, ['user', 'profileId'])
  )

  const options = useMemo(
    () => [
      {
        label: user.name,
        value: ''
      }
    ],
    [user.name]
  )

  // 首次创建则默认取当前登录人信息（前端不传值给后端），否则取会员的组织架构里面
  return detailData.id ? (
    <MemberDeptUserCascader
      allowClear={false}
      disabled={disabled}
      memberId={detailData.memberId}
      multiple={false}
      value={value}
      onChange={onChange}
    />
  ) : (
    <Select
      allowClear={false}
      defaultValue={profileId}
      disabled={disabled}
      labelInValue={false}
      options={options}
      value={''}
      onChange={onChange}
    />
  )
}
